import React from "react";
import messages from "../../../assets/locale/messages";
import Breadcrumbs from "../../../components/BreadCrumbs";
import { useSelector } from "react-redux";

const Applicants = () => {
  const lang = useSelector((state) => state.locale.lang);
  const { applicants } = messages[lang];

  return (
    <div className="applicants-page-container">
      <div className="page-title-margin">
        <Breadcrumbs
          list={[
            {
              path: "",
              label: applicants.applicantsList,
            },
          ]}
          BreadCrumbHasBackIcon={false}
        />
      </div>
    </div>
  );
};

export default Applicants;
